import React from "react";

//Custom Components
import CesiumPage from "@/views/ThreeD/CesiumPage";

function ThreeDPage() {

  return (
    <>
      <CesiumPage/>
    </>
  )

}

export default ThreeDPage;